import { useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

/**
 * Shared logout logic used by header, session expiry modal, etc.
 * Delegates session cleanup to AuthContext and preserves the login redirect fallback.
 * Delegates session cleanup to AuthContext and preserves the login redirect fallback.
 */
export const useLogout = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const performLogout = useCallback((options: { returnToVerification?: boolean } = {}) => {
    let raw: string | null = null;
    let verificationPath = options.returnToVerification ? '/error/session-expired' : '/';
    try {
      raw = localStorage.getItem('user-data');
    } catch {
      // ignore storage access issues
    }
    logout();
    if (raw) {
      try {
        const data = JSON.parse(raw);
        const loginURL = data?.loginURL;
        if (loginURL && !options.returnToVerification) {
          globalThis.location.href = loginURL;
          return;
        }
        const docId = data?.docId ?? data?.data?.docId ?? data?.body?.data?.docId;
        const iv = data?.iv ?? data?.IV;
        if (typeof docId === 'string' && docId) {
          verificationPath = `/${encodeURIComponent(docId)}${typeof iv === 'string' && iv ? `?iv=${encodeURIComponent(iv)}` : ''}`;
        } else if (options.returnToVerification) {
          verificationPath = '/error/session-expired';
        }
      } catch {
        // ignore invalid user data
      }
    }
    navigate(verificationPath);
  }, [logout, navigate]);

  return performLogout;
};

export default useLogout;